import { Component, OnInit, Renderer2, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { FirmaBilgileri } from '../_models/firmabilgileri';
import { SosyalMedya } from '../_models/sosyalmedya';
import { Kategori } from '../_models/kategori';
import { Router } from '@angular/router';
import { GlobalService } from '../_services/global.service';
import { isPlatformBrowser } from '@angular/common';
import { Program } from '../_models/program';
import { Netpol } from '../_models/netpol';
declare var $:any;

@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent implements OnInit {

  leftMenu = false;
  rightMenu = false;
  ProgramMenu = false;
  aramaMenu = false;
  aranacakData:string = '';

  firma:FirmaBilgileri = new FirmaBilgileri();
  sosyalMedya:SosyalMedya[] = [];
  kategoriler:Kategori[] = []
  programlar:Program[] = [];
  netpol:Netpol[] = [];

  constructor(
    private renderer: Renderer2, 
    private elmRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    private service:GlobalService,
    private router:Router
  ) {

     service.GetBasic('/FirmaBilgileri/front/1').subscribe((resp:FirmaBilgileri)=>{
     this.firma = resp;
     })

     service.GetBasic('/sosyalmedya/front').subscribe((resp:any[])=>{
       this.sosyalMedya = resp;
     })

    service.GetBasic('/program/front').subscribe((resp:Program[])=>{
      this.programlar = resp;
    })

    service.GetBasic('/Netpol/front').subscribe((resp:Netpol[])=>{
      console.log('sss' , resp)
      this.netpol = resp;
    })

   }
  

   ara(){
    // console.log(this.aranacakData);
     this.aramaMenu = false;
     this.router.navigate([`/arama-sonuclari/${this.aranacakData}`]);
     this.aranacakData = '';
   }



    // pipe yapılacak
 tarih: any;
 aylar: any[] = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']
 gunler: any[] = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi']
  ngOnInit() {
    const ay = new Date().getMonth();
    const gun = new Date().getDay();
    const gunAy = new Date().getUTCDate()
    const yil = new Date().getFullYear();
    console.log(ay, gun, this.aylar[ay])
    this.tarih = `${gunAy} ${this.aylar[ay]} ${yil} ${this.gunler[gun]}`

    if (isPlatformBrowser(this.platformId)) {
      // Sadece tarayıcıda çalışmasını istediğimiz kodlar burada yer alacak.
      // Örn: setTimeout, setInterval, localStorage, sessionStorage vb. komutlar bu if içerisinde olacak.
      let scrollPos;
      $(window).scroll(()=>{
        scrollPos = $(window).scrollTop();
        if (scrollPos > 600) {
          $('#stickyHeader').removeClass('stick-nonDisplay');
          setTimeout(()=>{
            $('#menuTop').removeClass('stickyMenu-spc');
          },250)
        } else {
          $('#stickyHeader').addClass('stick-nonDisplay');
          $('#menuTop').addClass('stickyMenu-spc');
        }
      })
     }
  }
}

